import React from "react";
import { useAuth } from "../../context/AuthContext";
import UploadLimits from "./UploadLimits";
import MySessions from "./MySessions";
import ChangePassword from "./auth/ChangePassword";
import { PageHeader } from "../../components/PageHeader";

export default function PlatformSettings({ readOnly }) {
  const { logout } = useAuth();
  return (
    <div data-testid="platform-settings">
      <PageHeader title="Pengaturan" description="Konfigurasi platform yang berlaku untuk seluruh pengguna, dan keamanan akun Anda." />
      <div className="mt-6 space-y-6">
        <UploadLimits readOnly={readOnly} />
        <MySessions onSignedOut={logout} />
        <ChangePassword />
      </div>
    </div>
  );
}
